<script setup>
import {
  ref,
  computed,
  defineEmits,
  //   onMounted,
  //   onBeforeUnmount,
} from "vue";
const activeTab = ref("one");
const options = ref([
  {
    name: "one",
    value: 1,
  },
  {
    name: "two",
    value: 2,
  },
  {
    name: "three",
    value: 3,
  },
]);
const selectedOption = ref(null);
const emit = defineEmits("update:modelValue");
const mappedSelectedOption = computed(() => {
  return (
    selectedOption.value?.name || selectedOption.value || "Up to 30 clients"
  );
});
const isDropDownVisible = ref(false);
const toggleOptionsSelect = (option) => {
  selectedOption.value = option;
  emit("update:modelValue", option);
  isDropDownVisible.value = !isDropDownVisible.value;
  activeTab.value = option.name;
};
</script>

<template>
  <div class="row pb-24">
    <div class="container">
      <div class="grid lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-10">
        <!-- col-1 -->
        <div
          class="card-subscribe-user border border-[#E7EAEE] rounded-xl shadow-lg p-[40px]"
        >
          <h3
            class="text-[#000] text-[20px] font-Approach font-semibold uppercase"
          >
            Grow plus
          </h3>
          <div class="flex flex-col gap-5">
            <div class="price-wrapper flex gap-5 items-center">
              <span class="price font-bold text-[#000] text-[44px]">$12</span>
              <div class="divider h-[16px] w-[1px] bg-[#B6B9CE]"></div>
              <span class="price text-[16px text-[#000] font-normal"
                >Month</span
              >
            </div>
            <div class="relative">
              <p class="text-[#000]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
                nulla tellus
              </p>
              <div
                @click="isDropDownVisible = !isDropDownVisible"
                role="button"
                class="drop-down hover:border-[#000] relative rounded-xl mt-8 flex p-4 justify-between border border-[#E6E6E6]"
              >
                <p class="text-[14px] text-[#07090D]">
                  {{ mappedSelectedOption }}
                </p>
                <img
                  class="object-contain object-center"
                  src="@/assets/images/Vector.png"
                  alt=""
                />
                <transition>
                  <ul
                    v-if="isDropDownVisible"
                    class="p-4 absolute rounded-xl bottom-[-188%] z-[99999999] w-full bg-[#000] left-0"
                  >
                    <li
                      v-for="(option, index) in options"
                      @click.self="toggleOptionsSelect(option)"
                      :key="index"
                      :class="
                        activeTab === option.name
                          ? 'text-[#FFF000]'
                          : 'text-[#fff] hover:text-[#FFF000] '
                      "
                    >
                      {{ option.name }}
                    </li>
                  </ul>
                </transition>
              </div>
              <button
                class="clip-btn w-full mt-6 bg-[#000] text-[#FFF000] justify-center gap-5 flex items-center"
              >
                <span class="font-[14px] font-semibold">Get Started</span
                ><svg
                  class="text-[#FFF000]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="8"
                  viewBox="0 0 9 8"
                  fill="none"
                >
                  <path
                    d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                    stroke="#FFF000"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  ></path>
                </svg>
              </button>
              <div class="devider my-5 bg-[#E7EAEE] w-full h-[1px]"></div>

              <ul class="list-none">
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >1 Unlimited Bandwidth</span
                  >
                </li>
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >2 PDF Access Sosmed</span
                  >
                </li>
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >1 Support System</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- end -->
        <!-- start-col-2 -->
        <div
          class="card-subscribe-user transform lg:scale-[1.1] bg-[#07090D] rounded-xl shadow-lg p-[40px]"
        >
          <h3
            class="text-[#FFF000] text-[20px] font-Approach font-semibold uppercase"
          >
            Busıness plan
          </h3>
          <div class="flex flex-col gap-5">
            <div class="price-wrapper flex gap-5 items-center">
              <span class="price font-bold text-[#FFFFFF] text-[44px]"
                >$12</span
              >
              <div class="divider h-[16px] w-[1px] bg-[#3C4353]"></div>
              <span class="price text-[16px text-[#FFFFFF] font-normal"
                >Month</span
              >
            </div>
            <div>
              <p class="text-[#ACB4C3]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
                nulla tellus
              </p>
              <div
                role="button"
                class="drop-down hover:border-[#FFF000] rounded-xl mt-8 flex p-4 justify-between border border-[#3C4353]"
              >
                <p class="text-[14px] text-[#fff]">Up to 30 clients</p>
                <img
                  style="
                    filter: brightness(0) saturate(100%) invert(100%)
                      sepia(100%) saturate(0%) hue-rotate(129deg)
                      brightness(102%) contrast(105%);
                  "
                  class="object-contain object-center"
                  src="@/assets/images/Vector.png"
                  alt=""
                />
              </div>
              <button
                class="clip-btn w-full mt-6 bg-[#FFF000] text-[#000000] justify-center gap-5 flex items-center"
              >
                <span class="font-[14px] font-semibold">Get Started</span
                ><svg
                  class="text-[#FFF000]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="8"
                  viewBox="0 0 9 8"
                  fill="black"
                >
                  <path
                    d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  ></path>
                </svg>
              </button>
              <div class="devider my-5 bg-[#3C4353] w-full h-[1px]"></div>

              <ul class="list-none">
                <li class="flex items-center mb-6 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="#FFF000"
                      />
                    </svg>
                  </i>
                  <span class="text-[#F6F7F9] text-[14px]"
                    >1 Unlimited Bandwidth</span
                  >
                </li>
                <li class="flex items-center mb-6 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="#FFF000"
                      />
                    </svg>
                  </i>
                  <span class="text-[#F6F7F9] text-[14px]"
                    >2 PDF Access Sosmed</span
                  >
                </li>
                <li class="flex items-center mb-6 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="#FFF000"
                      />
                    </svg>
                  </i>
                  <span class="text-[#F6F7F9] text-[14px]"
                    >1 Support System</span
                  >
                </li>
                <li class="flex items-center mb-6 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="#FFF000"
                      />
                    </svg>
                  </i>
                  <span class="text-[#F6F7F9] text-[14px]"
                    >12 Unlimited Bandwidth</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- end-col-2 -->

        <!--start-col-3  -->
        <div
          class="card-subscribe-user border border-[#E7EAEE] rounded-xl shadow-lg p-[40px]"
        >
          <h3
            class="text-[#000] text-[20px] font-Approach font-semibold uppercase"
          >
            Grow plus
          </h3>
          <div class="flex flex-col gap-5">
            <div class="price-wrapper flex gap-5 items-center">
              <span class="price font-bold text-[#000] text-[44px]">$12</span>
              <div class="divider h-[16px] w-[1px] bg-[#B6B9CE]"></div>
              <span class="price text-[16px text-[#000] font-normal"
                >Month</span
              >
            </div>
            <div>
              <p class="text-[#000]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
                nulla tellus
              </p>
              <div
                role="button"
                class="drop-down hover:border-[#000] rounded-xl mt-8 flex p-4 justify-between border border-[#E6E6E6]"
              >
                <p class="text-[14px] text-[#07090D]">Up to 30 clients</p>
                <img
                  class="object-contain object-center"
                  src="@/assets/images/Vector.png"
                  alt=""
                />
              </div>
              <button
                class="clip-btn w-full mt-6 bg-[#000] text-[#FFF000] justify-center gap-5 flex items-center"
              >
                <span class="font-[14px] font-semibold">Get Started</span
                ><svg
                  class="text-[#FFF000]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="8"
                  viewBox="0 0 9 8"
                  fill="none"
                >
                  <path
                    d="M2.5 1H7.5V6M7.5 1L1.5 7L7.5 1Z"
                    stroke="#FFF000"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  ></path>
                </svg>
              </button>
              <div class="devider my-5 bg-[#E7EAEE] w-full h-[1px]"></div>

              <ul class="list-none">
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >1 Unlimited Bandwidth</span
                  >
                </li>
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >2 PDF Access Sosmed</span
                  >
                </li>
                <li class="flex items-center mb-3 gap-4">
                  <i>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.6959 13.3442L12.7745 14.4228L19.2416 7.95574L20.3218 9.03588L12.7745 16.5831L7.91314 11.7217L8.99328 10.6416L10.6165 12.2648L11.6959 13.3434V13.3442ZM11.6974 11.1839L15.4802 7.40039L16.5573 8.47747L12.7745 12.261L11.6974 11.1839ZM9.53793 15.5037L8.45856 16.5831L3.59717 11.7217L4.67731 10.6416L5.75668 11.7209L5.75592 11.7217L9.53793 15.5037Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  <span class="text-[#07090D] text-[14px]"
                    >1 Support System</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--end-col-3  -->
      </div>
    </div>
  </div>
</template>

<style>
.dropdown-wrapper {
  padding: 16px;
  cursor: pointer;
  max-width: 200px;
  margin: 0 auto;
}
.dropdown-selected-option {
  padding: 16px;
  border: solid 1px #313131;
  border-radius: 9px;
  box-sizing: border-box;
  margin-bottom: 4px;
}
.option:hover {
  background: #c5c5c5;
}
.option {
  padding: 16px;
  border: solid 1px #313131;
  box-sizing: boder-box;
}
.option:last-of-type {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
